var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0774 11.7365C12.8986 11.7365 11.9424 10.7813 11.941 9.6024C10.5014 9.61824 9.34704 10.7986 9.36288 12.2381C9.37872 13.6776 10.559 14.832 11.9986 14.8162C13.4381 14.8003 14.5925 13.62 14.5766 12.1805C14.5747 12.0149 14.5574 11.8502 14.5243 11.688C14.3774 11.7197 14.2277 11.736 14.0774 11.7365Z",
    fill: "url(#paint0_linear_3_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0875 14.939C16.992 13.9992 16.6973 13.0901 16.2235 12.2726C16.0858 14.5051 14.2373 16.247 12 16.2509C11.8987 16.2509 11.8037 16.2283 11.7048 16.2206C9.4656 16.1914 7.32 15.3158 5.69904 13.7702C4.3056 12.4315 3.27216 10.7626 2.69424 8.9184C1.93152 9.61152 1.2096 10.3478 0.53136 11.1235C0.0455996 11.5733 0.0158396 12.3317 0.4656 12.8174C0.48672 12.8405 0.5088 12.8621 0.53136 12.8832C1.98912 14.6314 3.70704 16.1458 5.62416 17.3726C7.55232 18.6941 9.8352 19.4016 12.1728 19.4026C13.692 19.4112 15.191 19.0546 16.5437 18.3634C16.6291 18.324 16.703 18.2712 16.7875 18.2318C17.087 17.1619 17.1888 16.0454 17.0875 14.939Z",
    fill: "url(#paint1_linear_3_83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.256 13.9762C7.35648 12.3197 7.6752 10.2667 9.03456 8.96112C10.1026 7.52352 11.5992 6.46272 13.3094 5.93136C14.2416 5.64672 15.2093 5.49408 16.1837 5.47824C15.3994 5.1384 14.5786 4.89072 13.7376 4.74048C11.4341 4.35264 9.06672 4.74336 7.00992 5.8512C5.85936 6.44832 4.77312 7.16256 3.76944 7.98288C4.2432 9.79152 5.19936 11.4374 6.53568 12.745C7.0512 13.2302 7.63008 13.6445 8.256 13.9762Z",
    fill: "url(#paint2_linear_3_83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5003 11.1821C22.213 9.63984 20.7264 8.27616 19.0795 7.12608C17.3573 6.65568 15.5395 6.6648 13.8221 7.15248C13.3066 7.30992 12.8078 7.52112 12.3374 7.78464C13.0733 7.83648 13.7827 8.07984 14.3952 8.49072C14.4499 8.50656 14.5027 8.53008 14.5507 8.56032C16.5998 9.93648 17.9808 12.107 18.359 14.5464C18.4795 15.493 18.4646 16.451 18.3154 17.3933C20.2675 16.1525 22.0147 14.6165 23.495 12.839C23.9539 12.4118 23.9798 11.6933 23.5522 11.2344C23.5354 11.2162 23.5181 11.1989 23.5003 11.1821Z",
    fill: "url(#paint3_linear_3_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_83",
    x1: 12.0018,
    y1: 19.4027,
    x2: 12.0018,
    y2: 4.59461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_83",
    x1: 12.0018,
    y1: 19.4027,
    x2: 12.0018,
    y2: -1.53286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#32BEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C3F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_83",
    x1: 12.0018,
    y1: 18.4605,
    x2: 12.0018,
    y2: -1.90222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E8CE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#589EED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_83",
    x1: 18.0971,
    y1: 19.4112,
    x2: 18.0971,
    y2: 5.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#5EA0EF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purview.627859dbc0cff26ffd99bc96df1b8b73.svg";